var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardTicketPendingGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.302,
    height: 50.001,
    viewBox: "0 0 46.302 50.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 208",
    d: "M10.3 219.462.289 236.1a2.015 2.015 0 0 0 .688 2.765l9.322 5.609v-25.012z",
    transform: "translate(0 -198.03)",
    style: {
      fill: "#d3dae4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 209",
    d: "m377.987 42.025-9.323-5.609v25.012l10.01-16.638a2.015 2.015 0 0 0-.688-2.765z",
    transform: "translate(-332.662 -32.86)",
    style: {
      fill: "#d3dae4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 210",
    d: "M131.157 2.014v45.972A2.015 2.015 0 0 1 129.142 50h-6.457a4.474 4.474 0 0 0-8.762 0h-6.456a2.015 2.015 0 0 1-2.015-2.014V2.014A2.015 2.015 0 0 1 107.467 0h6.456a4.475 4.475 0 0 0 4.377 3.567A4.474 4.474 0 0 0 122.685 0h6.457a2.015 2.015 0 0 1 2.015 2.014z",
    transform: "translate(-95.154)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 211",
    d: "M131.157 2.014v45.972A2.015 2.015 0 0 1 129.142 50h-6.457a4.474 4.474 0 0 0-8.762 0h-6.456a2.015 2.015 0 0 1-2.015-2.014V2.014A2.015 2.015 0 0 1 107.467 0h6.456a4.475 4.475 0 0 0 4.377 3.567A4.474 4.474 0 0 0 122.685 0h6.457a2.015 2.015 0 0 1 2.015 2.014z",
    transform: "translate(-95.154)",
    style: {
      fill: "#f8915b",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 212",
    d: "M131.16 453.2v1.813a2.015 2.015 0 0 1-2.015 2.015h-6.457a4.474 4.474 0 0 0-8.763 0h-6.455a2.015 2.015 0 0 1-2.015-2.015V453.2a2.015 2.015 0 0 0 2.015 2.015h4.837a6.42 6.42 0 0 1 12 0h4.838a2.015 2.015 0 0 0 2.015-2.015z",
    transform: "translate(-95.156 -407.029)",
    style: {
      fill: "#b59e95",
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 213",
    d: "m86.892 243.383 1.813 1.091v-25.012l-1.813 3.014z",
    transform: "translate(-78.406 -198.03)",
    style: {
      fill: "#bfcbd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 214",
    d: "m370.478 37.507-1.813-1.091v25.012l1.813-3.014z",
    transform: "translate(-332.662 -32.86)",
    style: {
      fill: "#bfcbd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 215",
    d: "M131.141 346.771h-1.006a.755.755 0 1 0 0 1.509h1.022v-1.507h-.016zm-3.521 0h-1.006a.755.755 0 1 0 0 1.509h1.006a.755.755 0 1 0 0-1.509zm-3.521 0h-1.006a.755.755 0 1 0 0 1.509h1.007a.755.755 0 1 0 0-1.509zm-3.521 0h-1.006a.755.755 0 1 0 0 1.509h1.006a.755.755 0 0 0 0-1.509zm-3.521 0h-1.007a.755.755 0 1 0 0 1.509h1.006a.755.755 0 1 0 0-1.509zm-3.521 0h-1.006a.755.755 0 1 0 0 1.509h1.006a.755.755 0 1 0 0-1.509zm-3.521 0h-1.006a.755.755 0 1 0 0 1.509h1.006a.755.755 0 1 0 0-1.509zm-3.521 0h-1.006a.2.2 0 0 0-.034 0v1.505a.192.192 0 0 0 .034 0h1.006a.755.755 0 1 0 0-1.509z",
    transform: "translate(-95.154 -312.906)",
    style: {
      fill: "#d3dae4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 216",
    d: "M175.357 126.171a6.812 6.812 0 1 0 6.812 6.812 6.812 6.812 0 0 0-6.812-6.812zm2.3 9.107a.619.619 0 0 1-.876 0l-1.858-1.858a.619.619 0 0 1-.181-.438v-3.715a.619.619 0 1 1 1.238 0v3.459l1.676 1.676a.619.619 0 0 1 0 .876z",
    transform: "translate(-152.086 -113.849)",
    style: {
      fill: "#ff6b6b"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTicketPendingGrey);
export default __webpack_public_path__ + "static/media/dashboard-ticket-pending-grey.fb4d693dd84446aae228fcaa7c96cb75.svg";
export { ForwardRef as ReactComponent };